App.CategoryEditController = Em.Controller.extend
  session: Em.inject.service()

  env: Em.inject.service('environment')

  needs: [ 'categories', 'category', 'modifierGroupsIndex' ]

  sources: ['delivery_club', 'foodfox', 'broniboy', 'obed_ru', 'chibbis', 'glovo', 'vk', 'sbermarket']

  categoriesBinding: 'controllers.categories.model'
  rootCategoriesBinding: 'controllers.categories.rootCategories'
  flattenedCategoriesBinding: 'controllers.categories.flattenedCategories'
  categoryBinding: 'controllers.category.model'
  restaurantsBinding: 'controllers.categories.restaurants'
  modifierGroupsBinding: 'controllers.category.modifierGroups'
  enabledCustomRestaurantPrice: Em.computed.alias('category.organization.features.dish_restaurant_prices')
  showRestaurantPricesRecursiveOptions: Em.computed.alias('category.toggle_hidden_recursively')

  weightUnits: ['gram', 'kilogram', 'milliliter', 'liter']

  canEditMenu: Em.computed.alias('controllers.category.canEditMenu')
  cantEditMenu: Em.computed.alias('controllers.category.cantEditMenu')

  selectedHiddenRestaurant: null
  selectedHiddenRestaurantObserver: (->
    @set('category.toggle_hidden_restaurant_id', @get('selectedHiddenRestaurant.id'))
  ).observes('selectedHiddenRestaurant')

  toggleHiddenText: (->
    Em.I18n.t "category_edit.form.extras.toggle_hidden.#{Boolean @get('category.toggle_hidden')}"
  ).property('category.toggle_hidden')

  hiddenRestaurantLabel: (->
    Em.I18n.t 'category_edit.form.extras.toggle_hidden_restaurant_id'
  ).property()

  isSaving: false

  # Хеш с сообщениями валидации для полей модели
  validations: {}

  VALIDATABLE_FIELDS: [
    'parent_id'
  ]

  # ---
  # Извлекает сообщения валидации из модели в объект
  # можно вынести в миксин
  # ---
  extractValidations: (model, fields) ->
    errors = model.get('errors')
    validations = {}

    fields.forEach (field) =>
      if errors.has(field)
        validations[field] = errors.errorsFor(field).map (m) ->
          m.message
        .join(',')

    errors.clear()
    validations



  saveCategory: ->
    new Em.RSVP.Promise (resolve, reject) =>
      return reject() if @get('isSaving')

      @set('isSaving', true)

      category = @get('category')

      category.save()
      .then(resolve)
      .catch =>
        false
      .finally =>
        @set('validations', @extractValidations(category, @VALIDATABLE_FIELDS))
        @set('isSaving', false)

  actions:
    addExportHiddenSource: (source)->
      v = @get('category.export_hidden_sources_array').map((x) => x)
      v.push source
      @get('category').set('export_hidden_sources_array', v)

    removeExportHiddenSource: (source)->
      v = @get('category').get('export_hidden_sources_array')
      v = v.filter (s) =>
        s != source
      @get('category').set('export_hidden_sources_array', v)

    wouldUploadPhoto: (permission) ->
      category = @get('category')
      return permission.resolve() unless category.get('isNew')

      if confirm (Em.I18n.t 'categories.confirm.save_before_photo')
        @saveCategory().then =>
          permission.resolve()
        , =>
          permission.reject()
      else
        permission.reject()
      false

    delete: ->
      if confirm (Em.I18n.t 'categories.confirm.delete')
        category = @get('category')

        category.destroyRecord()
        .then =>
          @get('categories').removeObject(category)
          @transitionToRoute('categories')
      false

    acceptChanges: ->
      @saveCategory().then =>
        category = @get('category')
        @transitionToRoute('category', category.id)
      false

    discardChanges: ->
      @get('category').rollback()
      if @get('category.id')
        @transitionToRoute('category', @get('category'))
      else
        @get('categories').removeObject(@get('category'))
        @transitionToRoute('categories')
      false

    addDisabledSource: (source)->
      v = @get('category.disabled_sources_array').map((x) => x)
      v.push source
      @get('category').set('disabled_sources_array', v)

    removeDisabledSource: (source)->
      v = @get('category').get('disabled_sources_array')
      v = v.filter (s) =>
        s != source
      @get('category').set('disabled_sources_array', v)
